import { Box, Typography } from '@mui/material';
import { ReactComponent as NoteIcon } from 'assets/note-search.svg';
import { muiStyles } from './muiStyles';

const NoItems = () => (
  <Box sx={muiStyles.root}>
    <Box sx={muiStyles.icon}>
      <NoteIcon />
    </Box>
    <Typography variant='responsiveHeading3'>No Results Found</Typography>
    <Typography variant='responsiveBody3'>
      We couldn’t find any items matching your search. Try adjusting your keywords.
    </Typography>
  </Box>
);

export default NoItems;
